export enum CandidateInviteStatus {
  INVITED = 'invited',
  APPLIED = 'applied',
  IN_LIST = 'in_list'
}

export type CandidateProfileTableColumns = {
  id: string;
  name: string;
  location: string;
  currentCompany: string;
  currentJobTitle: string;
  timeInRole: string;
  yearsOfExperience: string;
  skills: string[];
  qualifications: string[];
  email: string;
  phone: string;
  atsCandidateId: string;
  externalUrl: string;
  originalSource: string;
  tags: string[];
  candidateProfileLists: string[];
  score?: number | null;
  explanation: string | null;
  inviteStatus: CandidateInviteStatus | null;
  // Per-organisation custom-field values, keyed by the config's logical fieldKey. The index
  // signature lets dynamic custom-field columns and their header filters key off the fieldKey.
  [customFieldKey: string]: unknown;
};
